import { isSeededFeatureFlagOn } from '../../../helpers/seededFeatureFlags';

export const isSpotlightRedesignSplitOn = (): boolean =>
	isSeededFeatureFlagOn('discover_spotlight_redesign_phase_0');
